import { SvgIconComponent } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import { IDocumentBundle } from "../../../models/configuration/bundles/IBundles";
import { DTDataGridAlignment, DTDataGridColumnType, IDataColumn } from "../../../models/IDataColumn";
import { SelectChangeEvent, Stack, Typography } from "@mui/material";
import React from "react";
import { IDataColumn as NewIDataColumn} from "../../../components/ui/dataGrid";
import DtStatusCell from "../../../components/ui/status/DtStatusCell";
import { DtExpandableText } from "../../../components/ui/text";

export const unsignedDocColumns = (
  editItem: (e: any, item: any) => void,
  deleteItem: (e: any, item: any) => void
): Array<IDataColumn> => {
  return [
    {
      name: "Edit",
      fieldId: "",
      datatype: DTDataGridColumnType.link,
      linkText: "Edit",
      foreColor: "blue",
      callbackFunction: editItem,
    },
    {
      name: "PackageId",
      fieldId: "PackageId",
      datatype: DTDataGridColumnType.text,
      readonly: true,
      sortable: true,
    },
    {
      name: "Bundling Option",
      fieldId: "BundlingOption",
      datatype: DTDataGridColumnType.text,
      sortable: true
    },
    {
      name: "Override Config Exists",
      fieldId: "OverrideConfigExists",
      datatype: DTDataGridColumnType.checkbox,
      alignment: DTDataGridAlignment.center,
      dataFunction: (x: IDocumentBundle) => {
        return x.DocumentHandlingPackageConfigs == null ? false : x.DocumentHandlingPackageConfigs?.length > 0
      }
    },
    {
      name: "Merge List Exists",
      fieldId: "",
      datatype: DTDataGridColumnType.checkbox,
      alignment: DTDataGridAlignment.center,
      dataFunction: (x: IDocumentBundle) => {
        return x.MergerPackageConfigs == null ? false : x.MergerPackageConfigs?.length > 0
      }
    },
    {
      name: "Delete",
      fieldId: "",
      datatype: DTDataGridColumnType.link,
      linkText: "Delete",
      foreColor: "firebrick",
      callbackFunction: deleteItem,
    },
  ];
};

export const signedDocColumns = (
  editItem: (e: any, item: any) => void,
  deleteItem: (e: any, item: any) => void
): Array<IDataColumn> => {
  return [
    {
      name: "Edit",
      fieldId: "",
      datatype: DTDataGridColumnType.link,
      linkText: "Edit",
      foreColor: "blue",
      callbackFunction: editItem,
    },
    {
      name: "PackageId",
      fieldId: "PackageId",
      datatype: DTDataGridColumnType.text,
      sortable: true
    },
    {
      name: "Bundling Option",
      fieldId: "BundlingOption",
      datatype: DTDataGridColumnType.text,
      sortable: true
    },
    {
      name: "Override Config Exists",
      fieldId: "OverrideConfigExists",
      datatype: DTDataGridColumnType.checkbox,
      alignment: DTDataGridAlignment.center,
      dataFunction: (x: IDocumentBundle) => {
        return x.DocumentHandlingPackageConfigs == null ? false : x.DocumentHandlingPackageConfigs?.length > 0
      }
    },
    {
      name: "Merge List Exists",
      fieldId: "",
      datatype: DTDataGridColumnType.checkbox,
      alignment: DTDataGridAlignment.center,
      dataFunction: (x: IDocumentBundle) => {
        return x.MergerPackageConfigs == null ? false : x.MergerPackageConfigs?.length > 0
      }
    },
    {
      name: "Delete",
      fieldId: "",
      datatype: DTDataGridColumnType.link,
      linkText: "Delete",
      foreColor: "firebrick",
      callbackFunction: deleteItem,
    },
  ];
};

export const otherDocColumns = (
  editItem: (e: any, item: any) => void,
  deleteItem: (e: any, item: any) => void
): Array<IDataColumn> => {
  return [
    {
      name: "Edit",
      fieldId: "",
      datatype: DTDataGridColumnType.link,
      linkText: "Edit",
      foreColor: "blue",
      callbackFunction: editItem,
      alignment: DTDataGridAlignment.center
    },
    {
      name: "Event Name",
      fieldId: "EventName",
      datatype: DTDataGridColumnType.text,
      sortable: true
    },
    {
      name: "Delete",
      fieldId: "",
      datatype: DTDataGridColumnType.link,
      linkText: "Delete",
      foreColor: "firebrick",
      callbackFunction: deleteItem,
    },
  ];
};

export const unsignedDocColumnsRef = (
): Array<NewIDataColumn> => [
  {
    name: "PackageId",
    fieldId: "PackageId",
    datatype: 'text',
    readonly: true,
    sortable: true,
  },
  {
    name: "Bundling Option",
    fieldId: "BundlingOption",
    datatype: 'text',
    sortable: true
  },
  {
    name: "Override Config Exists",
    fieldId: "OverrideConfigExists",
    datatype: 'text',
    sortable: false,
    width: 20,
    renderCell: (item: IDocumentBundle) => (
        <DtStatusCell
            exists={!!(item.DocumentHandlingPackageConfigs && item.DocumentHandlingPackageConfigs.length > 0)}
            yesText="Yes"
            noText="No"
        />
    ),
  },
  {
    name: "Merge List Exists",
    fieldId: "",
    datatype: 'text',
    sortable: false,
    width: 20,
    renderCell: (item: IDocumentBundle) => (
        <DtStatusCell
            exists={!!(item.MergerPackageConfigs && item.MergerPackageConfigs.length > 0)}
            yesText="Yes"
            noText="No"
        />
    ),
  }

];

export const signedDocColumnsRef = (): Array<NewIDataColumn> => [
  {
    name: "PackageId",
    fieldId: "PackageId",
    datatype: 'text',
    sortable: true
  },
  {
    name: "Bundling Option",
    fieldId: "BundlingOption",
    datatype: 'text',
    sortable: true
  },
  {
    name: "Override Config Exists",
    fieldId: "OverrideConfigExists",
    datatype: 'text',
    sortable: false,
    width: 20,
    renderCell: (x: IDocumentBundle) => (
        <DtStatusCell
            exists={!!(x.DocumentHandlingPackageConfigs && x.DocumentHandlingPackageConfigs.length > 0)}
            yesText="Yes"
            noText="No"
        />
    )
  },
  {
    name: "Merge List Exists",
    fieldId: "MergeListExists",
    datatype: 'text',
    width: 20,
    sortable: false,
    renderCell: (x: IDocumentBundle) => (
        <DtStatusCell
            exists={!!(x.MergerPackageConfigs && x.MergerPackageConfigs.length > 0)}
            yesText="Yes"
            noText="No"
        />
    ),
  }
];

export const otherDocColumnsRef = (
): Array<NewIDataColumn> => {
  return [
    {
      name: "Event Name",
      fieldId: "EventName",
      datatype: 'text',
      sortable: true, renderCell(row, rowIndex, pageConfig) {
        return (
          <Typography
          >
            {row.EventName || "No Event Name"}
          </Typography>
        );
      },
    },
  ];
};

export const packageConfigColumns = (
  _handleSelectChange: (e: SelectChangeEvent, item: any) => void,
  _handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>, item: any) => void,
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, item: any) => void,
  documentIds: Array<string>
): Array<IDataColumn> => {
  return [
    {
      name: "Docutech Index",
      fieldId: "DocumentIndex",
      datatype: DTDataGridColumnType.dropdownlist,
      dataOptions: documentIds,
      dataChangeFunction: handleInputChange
    },
    {
      name: "Docutech Form",
      fieldId: "DocumentName",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: false,
    },
    {
      name: "Encompass Folder",
      fieldId: "EncompassFolder",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true,
    },
    {
      name: "Suffix",
      fieldId: "Suffix",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true,
    },
    {
      name: "Encompass Attachment",
      fieldId: "EncompassAttachment",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true,
    },
  ];
};

export const packageConfigColumnsRef = (getCalculatedConfigValue: (item: any) => any, documentIds: Array<string>): Array<NewIDataColumn> => {
  return [
    {
      name: "Docutech Index",
      fieldId: "DocumentIndex",
      datatype: 'dropdownlist',
      dataOptions: documentIds,
      calculate(row) {
        return getCalculatedConfigValue(row);
      },
      editable: true,
      required: true,
      width: 10
    },
    {
      name: "Docutech Form",
      fieldId: "DocumentName",
      datatype: 'text',
      editable: true,
      disabled: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.DocumentName} />;
      }
    },
    {
      name: "Encompass Folder",
      fieldId: "EncompassFolder",
      datatype: 'text',
      editable: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.EncompassFolder} />;
      }
    },
    {
      name: "Suffix",
      fieldId: "Suffix",
      datatype: 'text',
      editable: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.Suffix} />;
      }
    },
    {
      name: "Encompass Attachment",
      fieldId: "EncompassAttachment",
      datatype: 'text',
      editable: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.EncompassAttachment} />;
      }
    },
  ];
};

export const mergePackageConfigColumns = (
  _handleSelectChange: (e: SelectChangeEvent, item: any) => void,
  _handleCheckboxChange: (e: React.ChangeEvent<HTMLInputElement>, item: any) => void,
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, item: any) => void,
  documentIds: Array<string>
): Array<IDataColumn> => {
  return [
    {
      name: "Merge List",
      fieldId: "MergeList",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true
    },
    {
      name: "Encompass Folder",
      fieldId: "EncompassFolder",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true
    },
    {
      name: "Encompass Attachment",
      fieldId: "EncompassAttachment",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true,
    },
    {
      name: "Suffix",
      fieldId: "Suffix",
      datatype: DTDataGridColumnType.text,
      dataChangeFunction: handleInputChange,
      editOnClick: true,
    },
  ];
};

export const mergePackageConfigColumnsRef = (
  documentIds: Array<string>
): Array<NewIDataColumn> => {
  return [
    {
      name: "Merge List",
      fieldId: "MergeList",
      datatype: 'text',
      dataOptions: documentIds,
      required: true,
      editable: true,
      renderCell(row) {
        // Display as comma separated string
        const value = Array.isArray(row.MergeList)
          ? row.MergeList.join(", ")
          : typeof row.MergeList === "string"
            ? row.MergeList
            : "";
        return <DtExpandableText showToggleLabel={false} value={value} />;
      },
      width: 15
    },
    {
      name: "Encompass Folder",
      fieldId: "EncompassFolder",
      datatype: 'text',
      required: true,
      editable: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.EncompassFolder} />;
      }
    },
    {
      name: "Encompass Attachment",
      fieldId: "EncompassAttachment",
      datatype: 'text',
      editable: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.EncompassAttachment} />;
      }
    },
    {
      name: "Suffix",
      fieldId: "Suffix",
      datatype: 'text',
      editable: true,
      renderCell(row) {
        return <DtExpandableText showToggleLabel={false} value={row?.Suffix ?? ''} />;
      },
      width: 10
    },
  ];
};

export const documentMappingColumns = (
  deleteItem: (e: any, item: any) => void,
  lookupItem: (e: any, item: any) => void,
  getForeColor: (item: any) => string | undefined,
  getBackColor: (item: any) => string | undefined,
  deleteIcon?: SvgIconComponent,
  lookupIcon?: SvgIconComponent,
): Array<IDataColumn> => {
  return [
    {
      name: "Docutech Index",
      fieldId: "DocumentIndex",
      datatype: DTDataGridColumnType.text,
      headerClass: "nowrap",
      sortable: true,
      backColorFunction: getBackColor
    },
    {
      name: "Docutech Form",
      fieldId: "ConformXDocumentName",
      datatype: DTDataGridColumnType.text,
      headerClass: "nowrap",
      sortable: true,
      backColorFunction: getBackColor
    },
    {
      name: "Encompass Document",
      fieldId: "EncompassDocumentName",
      datatype: DTDataGridColumnType.text,
      headerClass: "nowrap",
      sortable: true,
      foreColorFunction: getForeColor,
      backColorFunction: getBackColor
    },
    {
      name: "",
      fieldId: "",
      datatype: DTDataGridColumnType.image,
      alignment: DTDataGridAlignment.center,
      linkText: "Encompass Document",
      foreColor: "#143A6B",
      displayImage: lookupIcon,
      callbackFunction: lookupItem
    },
    {
      name: "",
      fieldId: "",
      datatype: DTDataGridColumnType.image,
      alignment: DTDataGridAlignment.center,
      linkText: "Delete",
      foreColor: "#b22222",
      displayImage: deleteIcon,
      callbackFunction: deleteItem
    },
  ];
};


export const documentMappingColumnsRef = (
  getForeColor: (item: any) => string | undefined,
  showItemLookup: (e: any, item: any) => void
): Array<NewIDataColumn> => {
  return [
    {
      name: "Docutech Index",
      fieldId: "DocumentIndex",
      datatype: 'text',
      sortable: true,
      width: 20,
      renderCell(row, rowIndex, pageConfig) {
        return (<Typography variant="body1" color={getForeColor(row)}>{row.DocumentIndex}</Typography>);
      },
    },
    {
      name: "Docutech Form",
      fieldId: "ConformXDocumentName",
      datatype: 'text',
      sortable: true,
      renderCell(row, rowIndex, pageConfig) {
         return (<Typography variant="body1" color={getForeColor(row)}>{row.ConformXDocumentName}</Typography>);
      },
    },
    {
      name: "Encompass Document",
      fieldId: "EncompassDocumentName",
      datatype: 'text',
      sortable: true,
      renderCell(row, rowIndex, pageConfig) {
        return (
          <Stack direction="row" alignItems='center' spacing={1}>
            <Typography
              variant="body1"
              color={row.ischanged ? 'error' : getForeColor(row)}>
              {row.EncompassDocumentName}
            </Typography>
            <EditIcon sx={{ fontSize: 18, cursor: 'pointer', color: theme => theme.palette.secondary.main }} onClick={(e) => showItemLookup(e, row)} />
          </Stack>
        );
      },
    }
  ];
};